import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv, PaginationRequest } from '@esg/shared';

interface GetEmployeeOverviewRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
        branchId?: string;
    };
}

export interface GetEmployeeOverviewResponse {
    totalEmployee: number;
}

export const getEmployeeOverview = httpUtil.createHttpRequestMeta<
    GetEmployeeOverviewRequest,
    GetEmployeeOverviewResponse
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/employees/overview',
    method: 'GET',
    authentication: 'bearer',
});